<template>
  <button
    class="search-control ui-btn"
    :class="{
      'search-control--root': root,
      'search-control--fade': getShouldFade
    }"
    @click.stop="emitClick"
    aria-label="Show the search input"
  >
    <Cross
      v-if="active"
      class="search-control__close-icon"
      :style="{ stroke: uiColor }"
    />
    <Spyglass
      v-else
      class="search-control__search-icon"
      :style="{ stroke: uiColor }"
    />
  </button>
</template>

<script>
import Cross from "@/assets/cross.svg"
import Spyglass from "./../../assets/search.svg"
import { mapState, mapGetters } from "vuex"

export default {
  props: {
    uiColor: String,
    active: Boolean,
    root: Boolean
  },

  components: {
    Cross,
    Spyglass
  },

  methods: {
    emitClick(e) {
      this.$emit("click", e)
    }
  },

  computed: {
    ...mapState("ui", ["navUiColour", "navActiveElement"]),
    ...mapGetters("breakpoints", ["GET_IS_BELOW_BREAKPOINT"]),

    getShouldFade() {
      return (
        /* this.GET_IS_BELOW_BREAKPOINT("md") && */
        this.navActiveElement && this.navActiveElement !== "search"
      )
    }
  }
}
</script>

<style lang="scss">
$stroke-width: 1.5px;

.search-control {
  cursor: pointer;
  position: relative;
  margin: 0 -8px;
  padding: 0 8px;
  pointer-events: all;
  transition: opacity 0.3s linear;

  &--root {
    * {
      opacity: 0;
    }
  }

  &--fade {
    opacity: 0.1;
  }

  &__search-icon,
  &__close-icon {
    // mix-blend-mode: difference;
    height: 22px;

    path {
      vector-effect: non-scaling-stroke;
    }

    @include media-breakpoint-up(xl) {
      height: 26px;
    }
  }

  &__search-icon {
    path {
      stroke: inherit;
      stroke-width: $stroke-width;
    }
  }

  &__close-icon {
    transform: scale(0.9);
    transform-origin: center;

    path {
      stroke: inherit;
      stroke-width: $stroke-width;
      fill: none;
    }
  }
}
</style>
